import { render, staticRenderFns } from "./CopyrightAssignmentTransferDetailsMessages.vue?vue&type=template&id=aae818d2&scoped=true&"
import script from "./CopyrightAssignmentTransferDetailsMessages.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferDetailsMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae818d2",
  null
  
)

export default component.exports